export const restLayer = {
  data() {
    return {
      layer: {
        desc: '',
        geoserver_data: {
          filename: '',
          coordinatessystem: 'EPSG:3857',
          workspace: '',
          datastore: ''
        },
        id_category: '-1',
        name: '',
        provider: {
          name: '',
          url: '',
          parsedurl: [],
          geoserverdata: {
            filename: '',
            coordinatessystem: 'EPSG:3857',
            workspace: '',
            datastore: '',
            maxfeatures: '',
            outputformat: '',
            request: '',
            service: '',
            version: ''
          }
        }
      },
      layers: [],
    }
  },
  methods: {
    getLayer: function () {
      var that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer)
        .then(function (response) {
          that.layer = response.data;
          console.log('get Layer', that.layer);
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    getLayersPages: function (page) {
      var that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/layers?page=' + page)
        .then(function (response) {
          that.layers = response.data;
          response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    getLayersByCategory: function (page, idCategory) {
      var that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/categories/' + idCategory + '/layers?page=' + page)
        .then(function (response) {
          that.layers = response.data;
          response.headers.totalpages == undefined ? that.totalPages = 0 : that.totalPages = parseInt(response.headers.totalpages, 10);
        })
    },
    getLayersNoPages: function () {
      var that = this;
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/')
        .then(function (response) {
          that.layers = response.data;
          return response.data;
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    postLayer: function () {
      console.log("[restLayer] Se va a enviar al backend la capa:", this.layer);
      var that = this;
      this.$http.post(this.$store.getters.backendurl + 'api/v1/layers',
        this.layer
      )
        .then(function (response) {
          //Obtener ID de la tarea recién creada y pasar a la vista de asignar usuarios
          let idLayer = response.data.id
          that.$router.push('/capas/' + idLayer + '/asignar-mapas')
        })
        .catch(function (error) {
          console.log("Error", error);
          console.log("Error Mes", error.response.data);
        });
    },
    putLayer: function () {
      console.log("[restLayer] Actualizar: Se va a enviar al backend la capa:", this.layer);
      var that = this;
      this.$http.put(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer,
        this.layer
      )
        .then(function (response) {
          //that.$router.push('/capas/' + that.$route.params.idLayer)
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    putLayerArcgis: function (data) {
      var that = this;
      console.log("[restLayerArcgis] Actualizar: Se va a enviar al backend la capa:", data);
      this.$http.put(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer,
        data
      )
        .then(function (response) {
          that.$router.push('/capas/' + that.$route.params.idLayer)
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    deleteLayer: function () {
      var that = this;
      this.$http.delete(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer)
        .then(function (response) {
          that.$router.push('/capas')
        })
        .catch(function (error) {
          console.log(error)
          that.message = error.response.data.message;
        });
    },
    postLayerArcgis: function (data) {
      var that = this;
      console.log("[restLayerArcgis] Se va a enviar al backend la capa:", data);
      const url = this.$store.getters.backendurl + 'api/v1/layers/arcgis'
      this.$http.post(url, data)
        .then(function (response) {
          console.log("[restLayerArcgis] Capa guardada exitosamente:", response.data);
          let idLayer = response.data.id
          that.$router.push('/capas/' + idLayer + '/asignar-mapas')
        })
        .catch(function (error) {
          console.log("[restLayerArcgis] Error al guardar la capa:", error);
        });
    },
  }
}